// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper___XEOPw","wrapper_reverse":"wrapper_reverse___eey2w","image":"image___YR3b2","p_wrapper":"p_wrapper___qbTNp","title":"title___cAfZF"};